export const TRADING_HOURS = {
  START: '03:45:00.000Z', // 9:15 AM IST
  END: '10:00:00.000Z',   // 3:30 PM IST
} as const

export const TIME_RANGES = {
  // '1D': { days: 1, label: '1 Day' },
  '1M': { days: 30, label: '1 Month' },
  '3M': { days: 90, label: '3 Months' },
  '6M': { days: 180, label: '6 Months' },
  '1Y': { days: 365, label: '1 Year' },
  '5Y': { days: 1825, label: '5 Years' },
  'MAX': { days: 0, label: 'Max' }
} as const

export const CHART_CONFIG = {
  price: {
    label: "Price",
    color: "hsl(var(--chart-1))",
  }
} as const